import MenuItemShareMedia from './MenuItemShareMedia';

export default MenuItemShareMedia;
